import Vue from 'vue'
import store from '@/store/index'
import Router from 'vue-router'
Vue.use(Router)
// const router = [
// ]
const route = new Router({
  mode: 'history',
  // 解决路由跳转后，不显示在首行
  scrollBehavior() {
    return {x: 0, y: 0};
  }
})
function loopAddition(data, name, id) {
  data.forEach(it => {
    // console.log(it.component, 1);
    // if (it.children && it.children.length > 0) {
    //   loopAddition(it.children, it.name, it.typeId)
    // } else {
    // if (it.component !== '') {
    route.addRoute(it)
    // if (id && it.parentId == id) {
    //   route.addRoute(name, it)
    // } else {
    //   // console.log(it);

    // }
    // } else {
    //   return
    // }

    // }
  })
  let ro =   {
    path: '*',
    redirect: '/'
  }
  route.addRoute(ro)
};
route.beforeEach((to, from, next) => {
  if (store.state.routes.length > 0) {
    let flag = store.state.orRoute.some(it =>
      it.path === to.path && (it.url != "" && it.url != null && it.url != undefined)
    )
    if (flag) {
      next()
    }
  } else {
    store.dispatch('getRoutes').then(res => {
      if (res.length > 0) {
        loopAddition(res)
        // console.log(to);
        // return {...to , replace:true}
        if (!to.name) {
          route.replace({
            path: to.path
          })
        } else next({ path: '/' })
      } else {
        next({ path: '/' })
      }
    })
  }
})
route.afterEach((to)=>{
// console.log(to);
if(to && to.meta){
  store.commit('setmenuName',to.meta.title)
}

})
export default route



// WEBPACK FOOTER //
// ./src/router/index.js